import { combineReducers } from "redux";
import broadcast_notification from "../features/admin/broadcast_notification/Slice";
import broadcast_notification_history from "../features/admin/broadcast_notification_history/Slice";

const notification = combineReducers({
  broadcast_notification: broadcast_notification,
  broadcast_notification_history: broadcast_notification_history,
});

export default notification;
